const GetForPID = () =>{
    const pidIsSet = JSON.parse(localStorage.getItem('Magazin_Caisse_LocalD'));
    return pidIsSet
}

const GetThemeMode = () =>{
    const theme = localStorage.getItem('Magazin_Caisse_Theme');
    return theme
}

const InputLinks =  {
    forPID: GetForPID(),
    themeColor: '#2f8d99',
    themeMode: GetThemeMode(),
    main : [
        {id:1, link:'nv', icon:'pc-display-horizontal', text:'CAISSES', desc:''},
        {id:2, link:'ft', icon:'receipt-cutoff', text:'TICKETS', desc:''},
        {id:3, link:'cd', icon:'truck', text:'COMMANDES', desc:''},
        {id:4, link:'recette', icon:'coin', text:'RECETTE', desc:''},
        
    ],

    //return back card 
    backCard:{
        nv : {id:1, text:'Nouveaux Facture', link:'/C/L'},
        edit : {id:1, text:'Nouveaux Facture', link:'/C/L'},
        pann : {id:1, text:'Nouveaux Facture', link:'/C/L'},

        mf : {id:7, text:'Mes Factures', link:'/C/L'},
        enAtt : {id:7, text:'Facture En Attent ', link:'/C/L/rt'},
        mfInfo : {id:8, text:'Facture Info', link:'/C/L/ft'},
        mfEdit : {id:8, text:'Modifier Facture', link:'/C/L/fr'},

        cd : {id:7, text:'Commandes', link:'/C/L'},
        cdInfo : {id:8, text:'Commandes Info', link:'/C/L/cd'},
        cdEdit : {id:8, text:'Modifier Commandes', link:'/C/L/cd'},

        rt : {id:1, text:'Recette', link:'/C/L'},
         
    },

  

}
export default InputLinks